import React from 'react'
// IMAGES
import imageCaseACocher from '../../../images/caseACocher.png'
import imageCaseACocherOk from '../../../images/caseACocherOk.png'
import imagePerson1 from '../../../images/person1.png'
import imagePerson2 from '../../../images/person2.png'
import imagePerson3 from '../../../images/person3.png'
import imagePerson4 from '../../../images/person4.png' 
import imagePerson5 from '../../../images/person5.png'

const ModalStaffServices = ({ services, valuesStaff, handleSelectService, staff }) => {

    const _colorPerson = (color) => {
        if (color === '7ddbd3ff') {
            return <img src={imagePerson1} alt='image du logo' style={{ height:25, width:25 }} />
        }
        if (color === 'cf92e1ff') {
            return <img src={imagePerson2} alt='image du logo' style={{ height:25, width:25 }} />
        }
        if (color === 'f6e2e5ff') {
            return <img src={imagePerson3} alt='image du logo' style={{ height:25, width:25 }} />
        }
        if (color === 'f3bd6aff') {
            return <img src={imagePerson4} alt='image du logo' style={{ height:25, width:25 }} />
        }
        if (color === '7ddbd3ff') {
            return <img src={imagePerson5} alt='image du logo' style={{ height:25, width:25 }} />
        }
    }

    return (
        <div className="modal fade" id="modalStaffServices" >
            <div className="modal-dialog modal-dialog-centered"> 
                <div className="modal-content">

                
                    <div className="modal-header">
                        {staff.filter(st => st.id === valuesStaff.idStaff).map(st => (
                            <div key={st.id} style={{ marginRight:'1rem'}}>{_colorPerson(st.circleColor)}</div>
                        ))}
                        <h5 className="modal-title" id="modalStaffServices">{valuesStaff.surnameStaff} {valuesStaff.nameStaff}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
                    </div>

                    <div className="modal-body">
                        
                        {services.filter(l => l.doc === 'docList').map(l => (
                            <div className='mb-3'>

                                {/* LISTE */}
                                <div 
                                    key={l.id} 
                                    className='text-center rounded-top p-2 border-bottom'
                                    style={{ backgroundColor:'lightgrey' }}
                                >{l.nameList}</div>

                                {/* SERVICES */}
                                {services.filter(s => s.nameList === l.nameList && s.doc === 'docService').sort((a,b) => a.nameService > b.nameService ? 1 : -1).map(s => (
                                    <div className='p-2 border-bottom border-start border-end'>
                                        <div className='row'>
                                            <div className='col-1' 
                                                onClick={() => [
                                                    handleSelectService(s.id, valuesStaff.idStaff, s[valuesStaff.idStaff])
                                                ]}
                                            >
                                                {s[valuesStaff.idStaff] === true ? 
                                                    <img src={imageCaseACocherOk} alt='image du logo' style={{ height:15, width:15 }} />
                                                : 
                                                    <img src={imageCaseACocher} alt='image du logo' style={{ height:15, width:15 }} />
                                                }
                                            </div>
                                            <div className='col'>
                                                <div 
                                                    key={s.id} 
                                                    style={{marginLeft:'-0.5rem', paddingTop:'0.12rem'}}
                                                >{s.nameService.charAt(0).toUpperCase() + s.nameService.slice(1)}</div>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                            </div>
                        ))} 
                    </div>

                </div>
            </div>
        </div>
    )
}

export default ModalStaffServices

/*
                                <div className='col-1 text-center'>
                                    {_colorPerson(l.circleColor)}
                                </div>

*/